import {lazy} from 'react';

export const SpecialistsResultAsync = lazy(() =>
    import('./SpecialistsResult')
);
